import React from "react";
import { Events } from "./event";
import "./app.scss";
import { Controls } from "./controls";
import { GameMap } from "./map";
export function App() {
    return React.createElement("div", { className: "app" },
        React.createElement("div", { className: "main" },
            React.createElement(GameMap, null),
            React.createElement(Controls, null)),
        React.createElement(Events, null));
}
